import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Image } from '@digsup/components-image';

import { styles } from './PolaroidCard.scss';

const cx = classNames.bind(styles);

/**
 * PolaroidCard component
 *  ~~~js
 *  import { PolaroidCard } from '@digsup/components-polaroid-card';
 *  ~~~
 */

export const PolaroidCard = ({
  imgSrc,
  imgAlt,
  isSelected,
  onClick,
  variant,
  actionType,
  className,
  children,
  ...props
}) => {
  const classes = cx(
    'c-pollaroid-card',
    {
      'c-pollaroid-card--selected': isSelected,
      'c-pollaroid-card--interactive': !!onClick,
      [`c-pollaroid-card--variant-${variant}`]: variant,
      [`c-pollaroid-card--action-${actionType}`]: actionType,
    },
    className,
  );

  const btnProps = onClick
    ? {
        role: 'button',
        tabIndex: 0,
        onKeyPress: e => {
          if (e.charCode === 13) {
            onClick?.();
          }
        },
        onClick: e => {
          e.currentTarget?.blur?.();
          onClick?.();
        },
      }
    : null;

  return (
    <div className={classes} {...btnProps} {...props}>
      <div className="c-pollaroid-card__placeholder" />
      <div className="c-pollaroid-card__inner">
        <div
          className={cx('c-pollaroid-card__img-wrapper', {
            [`c-pollaroid-card__img-wrapper--action-${actionType}`]: actionType,
            'c-pollaroid-card__img-wrapper--selected': isSelected,
          })}>
          <Image cover src={imgSrc} alt={imgAlt} />
        </div>
        <div className="c-pollaroid-card__content">{children}</div>
      </div>
    </div>
  );
};

PolaroidCard.propTypes = {
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  title: PropTypes.string,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'colorful']),
  actionType: PropTypes.oneOf(['delete', 'check']),
  className: PropTypes.string,
  children: PropTypes.any,
};

PolaroidCard.defaultProps = {
  imgAlt: '',
  isSelected: false,
  className: '',
};
